import { render, staticRenderFns } from "./Dictionary_level.vue?vue&type=template&id=50779a8d&style=height%3A100%25"
import script from "./Dictionary_level.vue?vue&type=script&lang=js"
export * from "./Dictionary_level.vue?vue&type=script&lang=js"
import style0 from "./Dictionary_level.vue?vue&type=style&index=0&id=50779a8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports